module.exports = __webpack_public_path__ + "media/promo/courses/images/reload-bea0078a1307c69ffc89157f8a3d89e7.png";